import {EventEmitter, forwardRef, Output, SimpleChanges} from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { IwgSelect } from 'src/app/shared/models/iwgselect.model';
import { BaseService } from 'src/app/shared/services';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => StateSelectComponent),
  multi: true
};

@Component({
  selector: 'app-state-select',
  templateUrl: './state-select.component.html',
  styleUrls: ['./state-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class StateSelectComponent implements OnInit,ControlValueAccessor {

  stateId: number;

  @Input() isDisabled = false;
  @Input() isRequired = false;
  @Input() alltext = 'All';
  items:IwgSelect[] = [];
  @Input() ShowHelp = false;
  @Input() labeltext = 'State';
  @Input() countryId: string;
  @Input() helptext = '';
  @Input() idOnly = false;
  @Input() disabled:boolean = false;
  @Input("country-id") countryic;
  @Input("preselected-item-id") preSelectedItem: any;
  @Input() selectedStateCode:any='';
  @Output() stateChange = new EventEmitter();

  isLoading:boolean = false;
  isOpen:boolean = false;

  constructor(private baseService: BaseService) { }

  ngOnInit(): void {
    if (!this.value) {
      this.value = -1;
    }
    if(this.selectedStateCode != -1) {
      this.get(true)
    }
  }

  private innerValue: any = '';
  get value(): any {return this.innerValue;};
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;this.onChangeCallback(v);
    }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value;}}
  registerOnChange(fn: any) {this.onChangeCallback = fn;}
  registerOnTouched(fn: any) {this.onTouchedCallback = fn;}

  ngOnChanges(changes: SimpleChanges){
      if ('preSelectedItem' in changes || 'countryId' in changes) {     
          if (this.preSelectedItem) {
              this.get(true);
          } else {
              this.get(false);
          }
    }
  }
  onOpen(event){
    this.isOpen = event;
    if(!event || this.items.length>0){
      return;
    }
    this.isLoading = true;
    this.get();
  }
  get(setId=false){
    const param = {country_id: this.countryId };
    this.baseService.getEntityData('STATE', param).pipe(catchError((err) => {
      throw (err);
    })).subscribe(
        data=>{
          this.isLoading = false;
          this.items = data.data.Data;
          if(this.preSelectedItem && setId && this.items){
            if(this.idOnly){
              this.value = this.items.find(item=>item.Abbreviation == this.preSelectedItem)
            }else{
              this.value = this.items.find(item=>item.ID == this.preSelectedItem)
            }
            if(this.preSelectedItem == -1){
              this.value = -1;
            }
          }         
          if(this.selectedStateCode!= -1 && setId && this.items && this.selectedStateCode!=="") {
              debugger;
              if(typeof this.selectedStateCode === 'object') {
              this.value = this.items.find(item=>item.Abbreviation == this.selectedStateCode.Abbreviation)
            }
            else {
              this.value = this.items.find(item=>item.Abbreviation == this.selectedStateCode)
            }   
          }
          // if(this.preSelectedItem != null && setId){
          //   //this.value = this.items.find(item=>item.ID == this.preSelectedItem)
          // }
        },
        err=>{
          this.isLoading = false;
          console.log(err);
        }
    );
  }
  getVal(){
    const param = {country_id: this.countryId };
    this.baseService.getEntityData('STATE', param).pipe(catchError((err) => {
      throw (err);
    }))
        .subscribe(result => {
              this.isLoading = false;
              if (result.apiCallStatus && result.data) {
                this.items = result.data.Data;
                if(this.idOnly){
                  // this.value = this.items.find(i=>i.Abbreviation == this.preSelectedItem);
                }
              }
            },
            error => {
              this.isLoading = false;
              console.log(error);
            });
  }

  objectComparison = function( option, value ) : boolean {
    if(option && value) {
      return (option.Abbreviation == value || option.ID == value || option.ID === value.ID);
    } else {
      return false;
    }
  }

  onStateChange($event): void {
    this.stateChange.emit($event.value);
  }

}
